export default function handleDispositionContainer(
  isHero,
  dispositionContainer,
  styles
) {
  if (isHero) {
    switch (dispositionContainer) {
      case 1:
        return styles._disposition_hero_one;
      case 2:
        return styles._disposition_hero_two;
      case 3:
        return styles._disposition_hero_three;
      case 4:
        return styles._disposition_hero_four;
      case 5:
        return styles._disposition_hero_five;
      case 6:
        return styles._disposition_hero_six;
      case 7:
        return styles._disposition_hero_seveen;
      case 8:
        return styles._disposition_hero_eight;
    }
  } else {
    switch (dispositionContainer) {
      case 1:
        return styles._disposition_container_one;
      case 2:
        return styles._disposition_container_two;
      case 3:
        return styles._disposition_container_three;
      case 4:
        return styles._disposition_container_four;
      case 5:
        return styles._disposition_container_five;
      case 6:
        return styles._disposition_container_six;
      case 7:
        return styles._disposition_container_seveen;
      case 8:
        return styles._disposition_container_eight;
      case 9:
        return styles._disposition_container_nine;
      case 10:
        return styles._disposition_container_ten;
      case 11:
        return styles._disposition_container_eleveen;
      case 12:
        return styles._disposition_container_12;
      case 13:
        return styles._disposition_container_13;
      case 14:
        return styles._disposition_container_14;
      case 15:
        return styles._disposition_container_15;
      case 16:
        return styles._disposition_container_16;
      case 17:
        return styles._disposition_container_17;
      case 18:
        return styles._disposition_container_18;
      case 19:
        return styles._disposition_container_19;
      case 20:
        return styles._disposition_container_20;
      case 21:
        return styles._disposition_container_21;
      case 22:
        return styles._disposition_container_22;
      case 23:
        return styles._disposition_container_23;
      case 24:
        return styles._disposition_container_24;
    }
  }
}
